
import { makeStyles } from '@material-ui/styles';

export default makeStyles({

align: {
    display: 'flex',
},
btnExportar: {
    width: '200px',
},
iconoExcel: {
    width: '12px',
    marginRight: '10px',
},
btnNuevaPresentacion: {
    marginLeft: '16px',
},
});